module.exports = {"430521001":"大禾塘街道","430521002":"两市塘街道","430521003":"宋家塘街道","430521101":"牛马司镇","430521103":"九龙岭镇","430521104":"仙槎桥镇","430521105":"火厂坪镇","430521106":"佘田桥镇","430521107":"灵官殿镇","430521108":"团山镇","430521109":"砂石镇","430521110":"廉桥镇","430521111":"流光岭镇","430521112":"流泽镇","430521113":"魏家桥镇","430521114":"野鸡坪镇","430521115":"杨桥镇","430521116":"水东江镇","430521117":"黑田铺镇","430521118":"简家陇镇","430521119":"界岭镇","430521203":"双凤乡","430521204":"周官桥乡","430521209":"堡面前乡","430521212":"斫曹乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430521.json
// module id = 1851
// module chunks = 0